<div class="response-journal-dialog">
  <!-- Close Icon -->
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>

  <!-- Servicios con Error -->
  <div class="response-journal-dialog__section response-journal-dialog__section--error"
    *ngIf="cargosJournalError.length">
    <div class="response-journal-dialog__header">
      <i class="fas fa-exclamation-triangle response-journal-dialog__icon response-journal-dialog__icon--error"></i>
      <h3 class="response-journal-dialog__title">
        Error al generar el Comprobante Contable para los siguientes servicios:
      </h3>
    </div>
    <div class="response-journal-dialog__content">
      <ul class="response-journal-dialog__list">
        <li class="response-journal-dialog__list-item" *ngFor="let cargo of cargosJournalError">
          <span class="response-journal-dialog__consecutive">Servicio {{cargo.consecutive}}</span>
          <span class="response-journal-dialog__error-message">: {{cargo.journalError.description}}</span>
        </li>
      </ul>
    </div>
    <div class="response-journal-dialog__actions" *ngIf="cargosJournalError.length">
      <button mat-raised-button class="primary-secondary button-width-auto" color="secondary-dark"
        (click)="onConfirm()">
        <i class="fas fa-redo-alt mr-2"></i>
        <span class="d-none d-sm-inline">Generar de nuevo</span>
      </button>
    </div>
  </div>

  <!-- Separador -->
  <div class="response-journal-dialog__divider" *ngIf="cargosJournalError.length && cargosJournalSuccess.length"></div>

  <!-- Servicios Exitosos -->
  <div class="response-journal-dialog__section response-journal-dialog__section--success"
    *ngIf="cargosJournalSuccess.length">
    <div class="response-journal-dialog__header">
      <i class="fas fa-check-circle response-journal-dialog__icon response-journal-dialog__icon--success"></i>
      <h3 class="response-journal-dialog__title">
        Comprobante Contable generado para los siguientes servicios:
      </h3>
    </div>
    <div class="response-journal-dialog__content">
      <ul class="response-journal-dialog__list response-journal-dialog__list--success">
        <li class="response-journal-dialog__list-item" *ngFor="let cargo of cargosJournalSuccess">
          <span class="response-journal-dialog__consecutive">Servicio {{cargo.consecutive}}</span>
        </li>
      </ul>
    </div>
  </div>
</div>